import { connect } from 'react-redux'
import CheckoutPayment from './CheckoutPayment'
import { getCheckoutContactActionRequest } from 'store/actions'

const mapStateToProps = state => ({
  color: '#d80417',
  lang: state.changeLang.lang
})

const mapDispatchToProps = dispatch => ({
  getCheckoutContactActionRequest: body =>
    dispatch(getCheckoutContactActionRequest(body))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckoutPayment)
